import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface DatabaseListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class DatabaseListPage extends Component<DatabaseListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.database(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}